import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../services/cms-converter/cms-converter.service'
import {
  AccordionMainContentContainerData
} from '../accordion/accordion-main-content-container/accordion-main-content-container.component.converter'

@Injectable({ providedIn: 'root' })
export class EditorialPDPAccordionContainerConverter extends CmsConverterService<EditorialPDPAccordionContainerData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      background: formData.st_backgroundcolor?.value?.identifier ?? '',
      headline: formData.st_accordion_main_headline ?? defaultTextInput,
      rows: formData.st_row ?? defaultFSCatalog,
      openPanelNumber: formData.st_number?.value ?? 0
    }
  }
}

export const EDITORIAL_PDP_ACCORDION_CONTAINER_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, EditorialPDPAccordionContainerData>>('EditorialPDPAccordionContainerConverter')

export type EditorialPDPAccordionContainerData = AccordionMainContentContainerData

